import {z} from 'zod';

import {multiString} from './multiString';
import {singleString} from './singleString';

/**
 * Single source of truth for direct-sales report filters.
 * Used both to parse incoming query params and as the `filters` echo in responses.
 */
export const directSalesFiltersSchema = z.object({
  closedFrom: singleString.pipe(
    z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD format')
      .optional()
  ),
  closedTo: singleString.pipe(
    z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD format')
      .optional()
  ),
  branch: multiString,
  variant: multiString,
});

export type DirectSalesFilters = z.infer<typeof directSalesFiltersSchema>;
